import React, { ComponentProps } from "react";

import "./LinkButton.scss";

function LinkButton({
  children,
  className = "",
  ...restProps
}: ComponentProps<"a">) {
  return (
    <a className={`custom-link-btn ${className}`} {...restProps}>
      {children}
    </a>
  );
}

export default LinkButton;
